/** 统一路由、界面和请求端的设备识别，兼容鸿蒙微信及桌面 UA 的 iPad。 */
export const detectMobileDevice = ({
  userAgent = "",
  platform = "",
  maxTouchPoints = 0,
  viewportWidth = 0,
} = {}) => {
  if (/Mobile|Android|iOS|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony/i.test(userAgent)) {
    return true;
  }
  if (/Mac/i.test(platform || userAgent) && maxTouchPoints > 1) {
    return true;
  }
  // 明确的桌面设备保持 PC，避免窄窗口触发手机路由。
  if (/Windows NT|Macintosh|X11|CrOS/i.test(userAgent)) {
    return false;
  }
  return viewportWidth > 0 && viewportWidth < 768;
};

const mobileDevice = detectMobileDevice({
  userAgent: typeof navigator === "undefined" ? "" : navigator.userAgent,
  platform: typeof navigator === "undefined" ? "" : navigator.platform,
  maxTouchPoints: typeof navigator === "undefined" ? 0 : navigator.maxTouchPoints,
  viewportWidth: typeof window === "undefined" ? 0 : window.innerWidth,
});

// 路由表在启动时选定；本次访问始终复用同一个结果，旋转/缩放不造成双端判断分裂。
export const isMobile = () => mobileDevice;
